import { useEffect, useState } from 'react';
import { BrowserRouter } from "react-router-dom";
import { createEmbeddingContext } from 'amazon-quicksight-embedding-sdk';
import MainMenu from './components/MainMenu/MainMenu';
import DashboardView from './views/Dashboard/DashboardView';
import UserManagementView from './views/UserManagement/UserManagementView';
import Q4BizEmbedding from './components/Q4BizEmbedding/Q4BizEmbedding'
import AppContext from './AppContext';
import Content from './components/Content/Content';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import { displayData } from './configs/DisplayData';
import MainModal from './components/Modal/Modal';
import Confirmation from './components/Confirmation/Confirmation';
import Home from './views/Home/Home.jsx';
import UseCaseView from './views/UseCase/UseCaseView';
import EventBanner from './components/EventBanner/EventBanner';
import ChatAgentView from './views/ChatAgent/ChatAgentView';
import ContactView from './views/Contact/ContactView';

const App = (props) => {
    
  const [availableDashboards, setAvailableDashboards] = useState(props?.config?.DashboardIds);
  const [menuTitle, setMenuTitle] = useState();
  const [user] = useState(props.user);
  const [userRole] = useState(props?.user?.signInUserSession?.idToken?.payload?.nickname);
  const [apiUrl] = useState(props?.config?.apiUrl);
  const [apiKey] = useState(props?.config?.apiKey);
  const [qUrl] = useState(props?.config?.qUrl);
  const [showWlsLogo] = useState(props?.config?.showWlsLogo);
  const [primaryColor] = useState(props?.config?.PrimaryColorParameter);
  const [secondaryColor] = useState(props?.config?.SecondaryColorParameter || '');
  const [transparentLogo] = useState(props?.config?.TransparentLogo);
  const [embedContext, setEmbedContext] = useState();
  const [dashboard, setDashboard] = useState();
  const [gridDisplay] = useState(displayData);
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const [confirmationContent, setConfirmationContentState] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const [qOpen, setQOpen] = useState(false);

  // const [realTime, setRealTime] = useState(false);
  // const [showRealTimeSwitch, setShowRealTimeSwitch] = useState(true);

  useEffect(() => {
    const setQuickSightUp = async () => {
      const embeddingContext = await createEmbeddingContext();
      setEmbedContext(embeddingContext)
    }
    setQuickSightUp();
  },[])

  useEffect(() => {
    setAvailableDashboards(props?.config?.DashboardIds)
  }, [props?.config?.DashboardIds])


  const [availableRoutes] = useState(!apiKey ?
    [
      { name: "Home", route: "/", component: "Home" },
      // Dropped the "/use-case/" prefix -- React Router v6 ranks static
      // paths (below) above this dynamic single-segment one regardless of
      // declaration order, so "/contact", "/q", "/user-management" etc.
      // still win over this catching their own path.
      { name: "Use Case", route: "/:useCaseId", component: "UseCaseView" },
      { name: "Chat Agent", route: "/agent/:agentId", component: "ChatAgentView" },
      { name: "Dashboard", route: "/dashboard/:dashboardId", component: "DashboardView" },
      { name: "Q for Business", route: "/q", component: "Q4BizEmbedding" },
      { name: "UserManagement", route: "/user-management", component: "UserManagementView" },
      { name: "Contact", route: "/contact", component: "ContactView" }
    ]
    : [
      { name: "Home", route: "/", component: "Home" },
      { name: "Use Case", route: "/:useCaseId", component: "UseCaseView" },
      { name: "Chat Agent", route: "/agent/:agentId", component: "ChatAgentView" },
      { name: "Dashboard", route: "/dashboard/:dashboardId", component: "DashboardView" },
      { name: "Contact", route: "/contact", component: "ContactView" }
    ]
  );

  const components = {
    'Home': Home,
    'UseCaseView': UseCaseView,
    'ChatAgentView': ChatAgentView,
    'DashboardView': DashboardView,
    'UserManagementView': UserManagementView,
    'Q4BizEmbedding': Q4BizEmbedding,
    'ContactView': ContactView
  }

  // useEffect(() => {
  //   if(!apiKey){
  //    setShowRealTimeSwitch(true)
  //   } else {
  //    setShowRealTimeSwitch(false)
  //   }
  //  }, [apiKey])

  const setModal = (content) => {
    setModalContent(content);
    setModalOpen(true);
  }

  const openModal = () => {
    setModalOpen(true);
  }

  const closeModal = () => {
    setModalOpen(false);
  }

  const setConfirmationContent = (content, confirmAction, header=null, cancelAction=null, workingMessage=null, yesButton=null, cancelButton=null ) => {    
    setConfirmationContentState({header, yesButton, cancelButton, content, confirmAction, cancelAction, workingMessage});
    setConfirmationOpen(true);
  }

  const closeConfirmation = () => {
    setConfirmationOpen(false);
    setConfirmationContentState(null);
  }

  const [appContext, setAppContext] = useState({
    availableRoutes,
    user,
    userRole,
    apiUrl,
    apiKey,
    qUrl,
    availableDashboards,
    primaryColor,
    secondaryColor,
    transparentLogo,
    menuTitle,
    setMenuTitle,
    embedContext,
    dashboard, 
    setDashboard,
    setQOpen,
    qOpen
  });

  useEffect(() => {
    const appContext = {
      availableRoutes,
      user,
      userRole,
      apiUrl,
      apiKey,
      qUrl,
      availableDashboards,
      primaryColor,
      secondaryColor,
      transparentLogo,
      menuTitle,
      setMenuTitle,
      embedContext,
      dashboard, 
      setDashboard,
      gridDisplay,
      showWlsLogo,
      modalOpen,
      modalContent,
      confirmationContent,
      confirmationOpen,
      setConfirmationContent,
      closeConfirmation,
      setModal,
      openModal,
      closeModal,
      qOpen,
      setQOpen
  
    };
    
    setAppContext(appContext);
  }, [
    availableRoutes, user, userRole, 
    apiUrl, apiKey, qUrl, availableDashboards, 
    showWlsLogo,
    primaryColor, secondaryColor, transparentLogo, menuTitle,
    embedContext, dashboard, 
    setDashboard, confirmationOpen, confirmationContent,
    gridDisplay, modalOpen, modalContent, qOpen, setQOpen
  ])


  return (
    <AppContext.Provider value={appContext} >
      <BrowserRouter>
        <ScrollToTop/>
        <MainMenu/>
        <EventBanner/>
        <Content components={components} />
        {modalOpen && <MainModal />}
        {confirmationOpen && <Confirmation /> }
      </BrowserRouter>
    </AppContext.Provider>
  );
}

export default App;